/**
 * @generated SignedSource<<e0cb8d7e645731aae739e4fbbc784dca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurriculumModuleListFragment$data = {
  readonly id: string;
  readonly modules: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentModuleListFragment">;
  };
  readonly " $fragmentType": "CurriculumModuleListFragment";
};
export type CurriculumModuleListFragment$key = {
  readonly " $data"?: CurriculumModuleListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurriculumModuleListFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentLabelIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurriculumModuleListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "modules",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "contentLabelIds",
              "variableName": "contentLabelIds"
            }
          ],
          "kind": "FragmentSpread",
          "name": "ContentModuleListFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Curriculum",
  "abstractKey": null
};

(node as any).hash = "53d63d00654d36befaae42331f7e7811";

export default node;
